/**
 * Admin — Engine Connections page — /admin/engines
 *
 * See AdminNav for the full list of admin sections.
 */
import React from 'react';
import { EngineConnectionsPanel } from '@/components/admin/EngineConnectionsPanel';
import { AdminPageShell } from '../_components/AdminPageShell';

export const AdminEnginesPage: React.FC = () => (
  <AdminPageShell title="Engine Connections">
    <EngineConnectionsPanel />
  </AdminPageShell>
);
